import {
  blueGrey,
  grey,
  brown,
  deepOrange,
  orange,
  lightBlue,
  blue,
  deepPurple,
  indigo,
  lime,
  lightGreen,
  teal,
  cyan,
  red,
  purple,
  pink,
} from '@material-ui/core/colors';

var colorCharacter = [
  { color: blueGrey, shade: 500 },
  { color: grey, shade: 600 },
  { color: brown, shade: 600 },
  { color: brown, shade: 300 },
  { color: deepOrange, shade: 300 },
  { color: orange, shade: 300 },
  { color: lightBlue, shade: 700 },
  { color: blue, shade: 200 },
  { color: deepPurple, shade: 100 },
  { color: indigo, shade: 200 },
  { color: lime, shade: 800 },
  { color: lightGreen, shade: 200 },
  { color: teal, shade: 200 },
  { color: cyan, shade: 600 },
  { color: blue, shade: 'A100' },
  { color: deepOrange, shade: 200 },
  { color: red, shade: 200 },
  { color: purple, shade: 200 },
  { color: indigo, shade: 400 },
  { color: grey, shade: 800 },
  { color: lightBlue, shade: 200 },
  { color: orange, shade: 'A100' },
  { color: orange, shade: 600 },
  { color: red, shade: 300 },
  { color: pink, shade: 200 },
  { color: grey, shade: 400 },
];
export class Inboxes {
  static isInboxSelected(
    selectedInboxes: { [key: string]: boolean },
    inbox,
  ) {
    return selectedInboxes[inbox.address];
  }
  static inboxesListApiToInboxAddresses(
    inboxes?: EachInboxResponse[],
  ): string[] {
    return inboxes?.map((inbox) => inbox.address) || [];
  }
  static inboxesListApiToInboxesNav(
    inboxes?: EachInboxResponse[],
  ): { [address: string]: InboxI } {
    if (!inboxes) return {};
    const colorCharN = Object.keys(colorCharacter).length;
    return inboxes.reduce((acc, eachInbox, index) => {
      const colorCode = colorCharacter[index % colorCharN].color;
      const shadeCode = colorCharacter[index % colorCharN].shade;
      return {
        ...acc,
        [eachInbox.address]: {
          ...eachInbox,
          color: colorCode[shadeCode],
        },
      };
    }, {});
  }
}

export class Inbox {
  inbox: EachInboxResponse;
  constructor(inbox) {
    this.inbox = inbox;
  }
  getLetterToShowInAvatar() {
    const a = this.inbox;
    if (!a) return '';
    return a.address && a.address.slice(0, 5) === 'ocps.'
      ? a.address[5].toUpperCase()
      : a.address[0].toUpperCase();
  }
}

export interface EachInboxResponse {
  id: number;
  address: string;
  imageUrl?: string;
  url?: string | null;
}

export interface InboxI extends EachInboxResponse {
  color: string;
}
